export default function WhyItMatters() {
  return (
    <section className="w-full bg-[#fefce8] py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-black text-secondary mb-4">
            Why Weatherstripping Matters
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          <div>
            <h3 className="text-xl md:text-2xl font-bold text-secondary mb-3">
              Energy Costs
            </h3>
            <p className="text-sm md:text-base text-[#374151] leading-relaxed">
              Worn weatherstripping is a top cause of energy loss. Hot air leaking in forces AC to work harder. Bill reduction within 1-2 months typical.
            </p>
          </div>
          <div>
            <h3 className="text-xl md:text-2xl font-bold text-secondary mb-3">
              Water &amp; Humidity
            </h3>
            <p className="text-sm md:text-base text-[#374151] leading-relaxed">
              Miami rain and humidity find every seal weakness. Failed weatherstripping leads to staining, drywall damage, mold. Early repair prevents major costs.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}